import type { TKesetaraanPackage, TLevel, TPhase } from 'types/classAndPhases'

import {
  LESS_THAN_OR_EQUAL_SYMBOL_URI,
  PLUS_MINUS_SYMBOL_URI,
} from 'utils/symbols'

export interface ThemeOption {
  label: string
  level: TLevel[]
}

export const THEME_OPTIONS: ThemeOption[] = [
  {
    label: 'Gaya Hidup Berkelanjutan',
    level: ['SD', 'SMP', 'SMA', 'SMK'],
  },
  {
    label: 'Kearifan Lokal',
    level: ['SD', 'SMP', 'SMA', 'SMK'],
  },
  {
    label: 'Bhinneka Tunggal Ika',
    level: ['SD', 'SMP', 'SMA', 'SMK'],
  },
  {
    label: 'Bangunlah Jiwa dan Raganya',
    level: ['SD', 'SMP', 'SMA', 'SMK'],
  },
  {
    label: 'Suara Demokrasi',
    level: ['SMP', 'SMA', 'SMK'],
  },
  {
    label: 'Rekayasa dan Teknologi',
    level: ['SD', 'SMP', 'SMA', 'SMK'],
  },
  {
    label: 'Kewirausahaan',
    level: ['SD', 'SMP', 'SMA'],
  },
  {
    label: 'Kebekerjaan',
    level: ['SMK'],
  },
  {
    label: 'Aku Sayang Bumi',
    level: ['PAUD'],
  },
  {
    label: 'Aku Cinta Indonesia',
    level: ['PAUD'],
  },
  {
    label: 'Kita Semua Bersaudara',
    level: ['PAUD'],
  },
  {
    label: 'Imajinasi dan Kreativitasku',
    level: ['PAUD'],
  },
]

export type TSLBPhaseDetail = { classes: string[]; mentalAge?: string }

export const SLB_DETAIL: Record<TPhase, TSLBPhaseDetail> = {
  Fondasi: {
    classes: ['PAUDLB'],
  },
  A: {
    classes: ['Kelas 1', 'Kelas 2'],
    mentalAge: `${decodeURI(LESS_THAN_OR_EQUAL_SYMBOL_URI)} 7`,
  },
  B: {
    classes: ['Kelas 3', 'Kelas 4'],
    mentalAge: `${decodeURI(PLUS_MINUS_SYMBOL_URI)} 8`,
  },
  C: {
    classes: ['Kelas 5', 'Kelas 6'],
    mentalAge: `${decodeURI(PLUS_MINUS_SYMBOL_URI)} 8`,
  },
  D: {
    classes: ['Kelas 7', 'Kelas 9'],
    mentalAge: `${decodeURI(PLUS_MINUS_SYMBOL_URI)} 9`,
  },
  E: {
    classes: ['Kelas 10'],
    mentalAge: `${decodeURI(PLUS_MINUS_SYMBOL_URI)} 10`,
  },
  F: {
    classes: ['Kelas 11', 'Kelas 12'],
    mentalAge: `${decodeURI(PLUS_MINUS_SYMBOL_URI)} 10`,
  },
}

export const KESETARAAN_PHASE_PACKET_MAPPING: Partial<
  Record<TPhase, TKesetaraanPackage>
> = {
  A: 'A',
  B: 'A',
  C: 'A',
  D: 'B',
  E: 'C',
  F: 'C',
}

export const GENERAL_PHASES: TPhase[] = [
  'Fondasi',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
]

export const classes = [
  'PAUD',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
]
const PAUD_MINUTES = 30
const SD_MINUTES = 35
const SMP_MINUTES = 40
const SMA_MINUTES = 45

export const SCHOOL_LEVEL_TO_MEETING_LENGTH = {
  'SD/sederajat': SD_MINUTES,
  'SMP/sederajat': SMP_MINUTES,
  'SMA/sederajat': SMA_MINUTES,

  PAUD: PAUD_MINUTES,
  PAUDLB: PAUD_MINUTES,
  SD: SD_MINUTES,
  SDLB: SD_MINUTES,
  SMP: SMP_MINUTES,
  SMPLB: SMP_MINUTES,
  SMA: SMA_MINUTES,
  SMK: SMA_MINUTES,
  SMALB: SMA_MINUTES,
} as const
